// extracted by mini-css-extract-plugin
export default {"section":"e+qikbkHZR","header":"h24L8lsycH","header-content":"_8tlaKvUdR4","headerContent":"_8tlaKvUdR4","title":"zWqVbVnF3m","description":"Xykiuy2zIK","expand-button":"+l0h1GRs5C","expandButton":"+l0h1GRs5C","content":"KS4VokpOpD"};
    if(module.hot) {
      // 1650538030812
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  